import * as React from "react";
const SvgContactsUser = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M21 22H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h15zm-2-2v-2H6a1 1 0 1 0 0 2zm-7-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-3 4h6a3 3 0 1 0-6 0" })));
export default SvgContactsUser;
//# sourceMappingURL=ContactsUser.js.map